import * as React from 'react';

import { Link } from 'react-router-dom';
import { Member } from 'common/api/models/Member';

export interface MemberLinkProps {
  member?: Member;
}
function handleClick(e: React.MouseEvent<any>) {
  e.stopPropagation();
}
export const MemberLink: React.SFC<MemberLinkProps> = props => {
  const member = props.member;
  if (!member) {
    return <span />;
  }
  const url = member.type === Member.Type.ORG ? '/orgs/' + member.number : '/users/' + member.number;
  return (
    <Link to={url} onClick={handleClick}>
      {member.name}
    </Link>
  );
};



// WEBPACK FOOTER //
// ./src/common/components/link/MemberLink.tsx